import angular from 'angular';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';

class MullionsService {
    constructor(config, windowDimensionsService) {
        this.config = config;
        this.windowDimensionsService = windowDimensionsService;
        this.mullionLen = -1;
    }

    addMulionToIntSashes(direction, sash) {
        const mullion = {};

        forEach(sash.intSashes, (el) => {
            const currentInternalSash = el;

            const newId = this.getNewMullionId();
            mullion.id = newId;

            if (angular.isUndefined(currentInternalSash.muntins)) {
                currentInternalSash.muntins = cloneDeep(this.config.jsonConfig.muntins);
            }
            if (angular.isUndefined(currentInternalSash.muntins[direction])) {
                currentInternalSash.muntins[direction] = [];
            }
            currentInternalSash.muntins[direction].push(cloneDeep(mullion));
        });
    }

    addMullionToSash(direction, sash) {
        const mullion = {};
        const currentSash = sash;

        mullion.id = this.getNewMullionId();

        if (angular.isUndefined(currentSash.muntins)) {
            currentSash.muntins = cloneDeep(this.config.jsonConfig.muntins);
        }

        currentSash.muntins[direction].push(cloneDeep(mullion));
    }

    getNewMullionId() {
        this.mullionLen++;

        return this.mullionLen;
    }

    getNewHorizontalIndex(index, lenX) {
        return Math.ceil((index + 1) / (lenX + 1));
    }

    resetMullionLength() {
        this.mullionLen = -1;
    }

    updateMuntinsDimensions(sash, index) {
        const currentSash = sash;
        if (isEmpty(currentSash.muntins)) {
            currentSash.muntins = this.config.jsonConfig.muntins;
        }
        if (sash.muntins.vertical) {
            const intSashWidth = this.windowDimensionsService.getSashWidth() /
                (this.windowDimensionsService.getVerticalDividersLength() + 1);
            const intSashHeight = this.windowDimensionsService.getIntSashHeight();
            if (isEmpty(currentSash.muntins)) {
                currentSash.muntins = this.config.jsonConfig.muntins;
            }
            const vertMuntinsLength = sash.muntins.vertical.length;
            const horMuntinsLength = sash.muntins.horizontal.length;

            forEach(sash.muntins.horizontal, (el, index1) => {
                const muntin = el;

                muntin.lengthInSash = intSashWidth;
                muntin.positionInSash = (index1 + 1) * (intSashHeight / (horMuntinsLength + 1));
            });

            forEach(sash.muntins.vertical, (el, index1) => {
                const muntinVert = el;
                muntinVert.lengthInSash = intSashHeight;
                muntinVert.positionInSash = (index1 + 1) * (intSashWidth / (vertMuntinsLength + 1));
            });
        } else {
            const intSashHeight = this.windowDimensionsService.getSashHeight(index) /
                (this.windowDimensionsService.getHorizontalDividersLength() + 1);
            let i;

            if (isEmpty(currentSash.muntins)) {
                currentSash.muntins = this.config.jsonConfig.muntins;
            }

            const vertMuntinsLength = this.windowDimensionsService.mullionsVert;
            const horMuntinsLength = this.windowDimensionsService.mullionsHor;

            for (i = 0; i < horMuntinsLength; ++i) {
                const muntin = currentSash.muntins[i];
                const positionInSash = sash.height / (this.windowDimensionsService.getMullionsHor() + 1);
                const lengthInSash = sash.width;

                if (muntin) {
                    muntin.start = {
                        x: 0,
                        y: positionInSash * (i + 1),
                    };

                    muntin.end = {
                        x: lengthInSash,
                        y: positionInSash * (i + 1),
                    };
                }
            }

            for (let j = 0; j < vertMuntinsLength; ++j) {
                const muntinVert = currentSash.muntins[j + i];

                const lengthInSash = intSashHeight;
                const positionInSash = sash.width / (this.windowDimensionsService.getMullionsVert() + 1);

                muntinVert.start = {
                    x: positionInSash * (j + 1),
                    y: 0
                };

                muntinVert.end = {
                    x: positionInSash * (j + 1),
                    y: lengthInSash,
                };
            }
        }
    }

    updateMullions(sash) {
        const currentSash = sash;
        const currentMuntins = currentSash.muntins;
        const width = currentSash.width / (this.windowDimensionsService.multiplierVert + 1);
        const height = currentSash.height;

        forEach(currentMuntins.horizontal, (el, index) => {
            const currentMuntin = el;
            const newIndex =
                this.getNewHorizontalIndex(index, this.windowDimensionsService.getMullionsVert());
            const basePosition = height / (this.windowDimensionsService.getMullionsHor() + 1);

            currentMuntin.lengthInSash = width;
            currentMuntin.positionInSash = newIndex * basePosition;
        });

        forEach(currentMuntins.vertical, (el, index) => {
            const currentMuntin = el;

            currentMuntin.lengthInSash = height;
            currentMuntin.positionInSash = (index + 1) * width;
        });
    }
}

MullionsService.$inject = [
    'config',
    'windowDimensionsService'
];

export default angular.module('mullionsService', [])
    .service('mullionsService', MullionsService)
    .name;